import { render, staticRenderFns } from "./CommodityManage.vue?vue&type=template&id=39b6230e&scoped=true"
import script from "./CommodityManage.vue?vue&type=script&lang=js"
export * from "./CommodityManage.vue?vue&type=script&lang=js"
import style0 from "./CommodityManage.vue?vue&type=style&index=0&id=39b6230e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6230e",
  null
  
)

export default component.exports